var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTableFooter from '@material-ui/core/TableFooter';
/**
 * Kareo wrapped component of the Material-UI TableFooter. The prop API has been limited to props defined in TableFooterProps.
 *
 * Material-UI TableFooter: [Docs](https://v4.mui.com/components/tables/), [API](https://v4.mui.com/api/table-footer/)
 *
 * @storybook: [Table](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-table--table-main-story)
 */
var TableFooter = React.forwardRef(function (props, ref) { return (React.createElement(MuiTableFooter, __assign({}, props, { ref: ref }))); });
TableFooter.displayName = 'KareoTableFooter';
export default TableFooter;
